import { kanaele } from "./Kanaele";

const zs3 = kanaele.find(k => k.label === 'ZS 3')
const zs4 = kanaele.find(k => k.label === 'ZS 4')
const zs5 = kanaele.find(k => k.label === 'ZS 5')

export const tasks = [
    {type: 'joinChannel', params: {mode: zs3.mode, number: zs3.number}, label: `Kanal ${zs3.label} wählen`, categories: ['Kanal wählen']},
    {type: 'joinChannel', params: {mode: zs4.mode, number: zs4.number}, label: `Kanal ${zs4.label} wählen`, categories: ['Kanal wählen']},
    {type: 'joinChannel', params: {mode: zs5.mode, number: zs5.number}, label: `Kanal ${zs5.label} wählen`, categories: ['Kanal wählen']},
    {type: 'powerOff', params: {}, label: 'Gerät ausschalten', categories: ['Ausschalten']},
    {type: 'exitChannel', params: {}, label: 'Kanal verlassen', categories: ['Kanal verlassen']},
    {type: 'properShutdown', params: {}, label: 'Kanal verlassen, dann Gerät ausschalten', categories: ['Kanal verlassen', 'Ausschalten']}
]